import {getActivePageId} from '../Header.utils'

export const isActiveClassicUILink = (page: string): boolean => getActivePageId() === page
